export const iconFontAwesomeMoneyRupeeSign = (
	<i className="fa-solid fa-rupee-sign"></i>
);
